import axios from 'axios';
import { API_BASE_URL } from '../utils/constants';

export interface OrderTrendsData {
  labels: string[];
  datasets: {
    label: string;
    data: number[];
    backgroundColor: string;
    borderColor: string;
    borderWidth: number;
  }[];
}

export interface RevenueGrowthData {
  labels: string[];
  datasets: {
    label: string;
    data: number[];
    borderColor: string;
    backgroundColor: string;
    fill: boolean;
    tension: number;
  }[];
}

export interface RevenueSummaryData {
  yesterday: number;
  last7days: number;
  last30days: number;
  last1year: number;
}

export interface AnalyticsResponse {
  status: 'success' | 'error';
  data?: {
    orderTrends: OrderTrendsData;
    revenueGrowth: RevenueGrowthData;
    revenueSummary: RevenueSummaryData;
  };
  message?: string;
}

export const analyticsApi = {
  // Get all analytics data
  async getAll(): Promise<AnalyticsResponse> {
    try {
      const token = localStorage.getItem('auth_token');
      const response = await axios.get(`${API_BASE_URL}/analytics.php?action=get_all`, {
        headers: {
          'Authorization': token ? `Bearer ${token}` : '',
          'Content-Type': 'application/json',
        },
      });
      return response.data as AnalyticsResponse;
    } catch (error: any) {
      console.error('Analytics API error:', error);
      return {
        status: 'error',
        message: error.message || 'Failed to fetch analytics data'
      };
    }
  },

  // Get order trends data
  async getOrderTrends(): Promise<AnalyticsResponse> {
    try {
      const token = localStorage.getItem('auth_token');
      const response = await axios.get(`${API_BASE_URL}/analytics.php?action=order_trends`, {
        headers: {
          'Authorization': token ? `Bearer ${token}` : '',
          'Content-Type': 'application/json',
        },
      });
      return response.data as AnalyticsResponse;
    } catch (error: any) {
      console.error('Order trends API error:', error);
      return {
        status: 'error',
        message: error.message || 'Failed to fetch order trends'
      };
    }
  },

  // Get revenue growth data
  async getRevenueGrowth(): Promise<AnalyticsResponse> {
    try {
      const token = localStorage.getItem('auth_token');
      const response = await axios.get(`${API_BASE_URL}/analytics.php?action=revenue_growth`, {
        headers: {
          'Authorization': token ? `Bearer ${token}` : '',
          'Content-Type': 'application/json',
        },
      });
      return response.data as AnalyticsResponse;
    } catch (error: any) {
      console.error('Revenue growth API error:', error);
      return {
        status: 'error',
        message: error.message || 'Failed to fetch revenue growth'
      };
    }
  },

  // Get revenue summary data
  async getRevenueSummary(): Promise<AnalyticsResponse> {
    try {
      const token = localStorage.getItem('auth_token');
      const response = await axios.get(`${API_BASE_URL}/analytics.php?action=revenue_summary`, {
        headers: {
          'Authorization': token ? `Bearer ${token}` : '',
          'Content-Type': 'application/json',
        },
      });
      return response.data as AnalyticsResponse;
    } catch (error: any) {
      console.error('Revenue summary API error:', error);
      return {
        status: 'error',
        message: error.message || 'Failed to fetch revenue summary'
      };
    }
  }
};
